import { SxProps } from '@mui/material'
import Box from '@mui/material/Box'
import { CSSProperties, ReactNode } from 'react'

interface Props {
  children: ReactNode
  style?: CSSProperties
}

export default function ModalActionContainer(props: Props) {
  return (
    <Box
      sx={
        {
          ...containerStyle,
          ...props.style,
        } as SxProps
      }
    >
      {props.children}
    </Box>
  )
}

const containerStyle: SxProps = {
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: '16px',
  marginBottom: '8px',
  gap: '16px',
  '& > button': {
    padding: '4px 16px',
  },
}
